import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  StudentFeeStructureMappingCreateRequestDTO,
  StudentFeeStructureMappingDTO,
  StudentFeeStructureMappingUpdateRequestDTO,
  StudentFeeStructureMappingList,
  StudentFeeStructureMappingDeleteRequestDTO,
  StudentFeeStructureMappingReadByIdRequestDTO,
  StudentFeeStructureMappingReadByClassIdRequestDTO,
  StudentFeeStructureMappingReadByStudentIdRequestDTO,
  StudentFeeStructureMappingReadByFeeStructureIdRequestDTO
} from './student-fee-structure-mapping.interface';
import {
  StudentFeeStructureMapping_Create,
  StudentFeeStructureMapping_Delete,
  StudentFeeStructureMapping_ReadAll,
  StudentFeeStructureMapping_ReadByClassId,
  StudentFeeStructureMapping_ReadByFeeStructureId,
  StudentFeeStructureMapping_ReadById,
  StudentFeeStructureMapping_ReadByStudentId,
  StudentFeeStructureMapping_Update
} from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class StudentFeeStructureMappingService {

  constructor() { }

  http = inject(HttpClient)


  StudentFeeStructureMapping_Create(data: StudentFeeStructureMappingCreateRequestDTO): Observable<StudentFeeStructureMappingDTO> {
    return this.http.post<StudentFeeStructureMappingDTO>(StudentFeeStructureMapping_Create, data)
  }

  StudentFeeStructureMapping_Update(data: StudentFeeStructureMappingUpdateRequestDTO): Observable<StudentFeeStructureMappingDTO> {
    return this.http.post<StudentFeeStructureMappingDTO>(StudentFeeStructureMapping_Update, data)
  }

  StudentFeeStructureMapping_ReadAll(): Observable<StudentFeeStructureMappingList> {
    return this.http.get<StudentFeeStructureMappingList>(StudentFeeStructureMapping_ReadAll)
  }

  StudentFeeStructureMapping_Delete(data: StudentFeeStructureMappingDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(StudentFeeStructureMapping_Delete, data)
  }

  StudentFeeStructureMapping_ReadById(data: StudentFeeStructureMappingReadByIdRequestDTO): Observable<StudentFeeStructureMappingDTO> {
    return this.http.post<StudentFeeStructureMappingDTO>(StudentFeeStructureMapping_ReadById, data)
  }

  StudentFeeStructureMapping_ReadByClassId(data: StudentFeeStructureMappingReadByClassIdRequestDTO): Observable<StudentFeeStructureMappingList> {
    return this.http.post<StudentFeeStructureMappingList>(StudentFeeStructureMapping_ReadByClassId, data)
  }

  StudentFeeStructureMapping_ReadByStudentId(data: StudentFeeStructureMappingReadByStudentIdRequestDTO): Observable<StudentFeeStructureMappingList> {
    return this.http.post<StudentFeeStructureMappingList>(StudentFeeStructureMapping_ReadByStudentId, data)
  }

  StudentFeeStructureMapping_ReadByFeeStructureId(data: StudentFeeStructureMappingReadByFeeStructureIdRequestDTO): Observable<StudentFeeStructureMappingList> {
    return this.http.post<StudentFeeStructureMappingList>(StudentFeeStructureMapping_ReadByFeeStructureId, data)
  }

}
